import { chartDarkOptions, chartLightOptions, defaultPriceScaleOptions, watermarkUrl } from './constant';
import { ImageWatermark } from './plugin/image-watermark';
import { type ChartOptions, ColorType, type DeepPartial, ImageWatermarkOptions, LineStyle } from 'lightweight-charts';

export const margeChartOptions = (options: DeepPartial<ChartOptions>, theme: 'light' | 'dark' | string = 'light') => {
  const chartOptions = theme === 'dark' ? chartDarkOptions : chartLightOptions;
  return {
    autoSize: true,
    handleScale: false,
    handleScroll: false,
    ...options,
    localization: {
      locale: 'en-US',
      ...options?.localization,
    },
    layout: {
      textColor: chartOptions.textColor,
      fontSize: chartOptions.fontSize,
      fontFamily: chartOptions.fontFamily,
      secondsVisible: false,
      attributionLogo: false,
      ...options?.layout,
      background: { type: ColorType.Solid, color: chartOptions.backgroundColor, ...options?.layout?.background },
    },
    crosshair: {
      ...options?.crosshair,
      vertLine: {
        color: chartOptions.lineColor,
        visible: false,
        style: LineStyle.Solid,
        labelVisible: false,
        labelBackgroundColor: chartOptions.lineColor,
        ...options?.crosshair?.vertLine,
      },
      horzLine: {
        color: chartOptions.lineColor,
        visible: false,
        labelVisible: false,
        labelBackgroundColor: chartOptions.lineColor,
        ...options?.crosshair?.horzLine,
      },
    },
    grid: {
      vertLines: {
        visible: false,
        style: LineStyle.Dashed,
        color: chartOptions.borderColor,
        ...options?.grid?.vertLines,
      },
      horzLines: {
        visible: false,
        style: LineStyle.Dashed,
        color: chartOptions.borderColor,
        ...options?.grid?.horzLines,
      },
    },
    leftPriceScale: {
      ...defaultPriceScaleOptions,
      borderColor: chartOptions.borderColor,
      ...options?.leftPriceScale,
    },
    rightPriceScale: {
      ...defaultPriceScaleOptions,
      borderColor: chartOptions.borderColor,
      ...options?.rightPriceScale,
    },
    timeScale: {
      borderVisible: false,
      fixLeftEdge: true,
      fixRightEdge: true,
      allowBoldLabels: false,
      tickMarkMaxCharacterLength: 20,
      borderColor: chartOptions.borderColor,
      ...options?.timeScale,
    },
  } as DeepPartial<ChartOptions>;
};

export const createLogoWatermarkPlugin = (imageUrl = watermarkUrl, options?: ImageWatermarkOptions) => {
  return new ImageWatermark(imageUrl, {
    maxWidth: 171,
    maxHeight: 24,
    alpha: 0.08,
    placement: {
      x: 16,
      y: 16,
    },
    ...options,
  });
};
